<template >
    <div>
         <b-navbar toggleable="lg" type="dark" variant="primary"  >
            <b-navbar-brand href="#">
                <b-icon   icon="person-square"></b-icon>  {{ $route.query.desc }} </b-navbar-brand>
                 <b-navbar-nav class="ml-auto">
                 <!-- <b-nav-item-dropdown right>
                           
                            <template #button-content>
                                ພາສາ
                            </template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

                <b-nav-item @click="goback()" > 
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <b-card class="m-5">
            <b-form @submit.prevent="onPreview">
            <b-row>
                <b-col  >
                    <b-form-group  label="ແຕ່ວັນທີ:" label-cols="4">
                        <b-form-datepicker v-model="fld.fromdate" locale="lao"></b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col  >
                    <b-form-group label="ເຖິງວັນທີ:" label-cols="4">
                        <b-form-datepicker v-model="fld.todate" locale="lao"></b-form-datepicker>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group :label="$t('users.prov_id')" label-cols="4">
                        <b-form-select v-model="fld.prov_id" :options="provices" required @input="getBorders">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>



            <b-row>
                <b-col>
                    <b-form-group :label="$t('users.border_id')" label-cols="4">
                        <b-form-select v-model="fld.border_id" :options="borders" required></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
              <b-button block  type="submit" variant="outline-primary"> {{$t('button.preview')}} </b-button>
           

        </b-form>
        </b-card>
        

    </div>
</template>
<script>
import axios from "axios";
export default {

    data() {
        return {
            fld:{
                fromdate:"",
                todate:"",
                prov_id:"",
                border_id:"",
                reportname: this.$route.query.reportname

            },
            provices: [],
            borders: [],
        }
    },
    created() {
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/provinces/province_lao/prov_id"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.provices = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                console.log(e);
            });

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },

        getBorders() {
            //getItemsCondition
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getItemsCondition/borders/border_name_lao/border_id/prov_id/" + this.fld.prov_id
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.borders = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onPreview(){
            let data = JSON.stringify(this.fld);
             this.$router.push('/report3/rpt_visabroken.mrt?data='+data)
        }
    },
}
</script>
<style  scoped >
.content {
    margin-top: 80px;
}

.notolao {
    font-family: 'Noto Sans Lao Regular', 'Phetsarath OT';
}
</style>